<template>
  <div class="animated fadeIn">
    <b-row class="mb-3">
      <b-col md="2" class="pt-2">Grower</b-col>
      <b-col v-if="projectFormStepOne.customer_id">
        <b-input-group>
          <b-form-select
            v-model="selected_customer_grower_id"
            :options="customer_grower_options"
          >
            <template slot="first">
              <option :value="null">
                Select Grower
              </option>
            </template>
          </b-form-select>
        </b-input-group>
      </b-col>
      <b-col>
        <b-input-group>
          <b-form-input
            type="text"
            v-model="grower"
            placeholder="Submission Grower"
            :state="!$v.grower.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-form-group label="Irrigated?" :label-cols="2" :horizontal="true">
          <b-form-checkbox
            v-model="irrigated"
            :value="1"
            :unchecked-value="0"
            class="pt-1"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate/src";
import { required } from "vuelidate/lib/validators";
import CustomerGrowerCollection from "@/collections/crm/CustomerGrowerCollection";

export default {
  name: "ProjectSoilFieldFormGroups",
  mixins: [validationMixin, ToastNotifications],
  props: {
    submissionId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      customer_grower: null,
      selected_customer_grower_id: null,
    };
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission",
      projectFormStepOne: "projectFormStepOne",
    }),
    currentSubmission() {
      return this.submission(this.submissionId);
    },
    submission_soil() {
      return this.currentSubmission.submission_soil;
    },
    grower: {
      get() {
        return this.submission_soil.grower;
      },
      set(value) {
        this.handleSubmissionDeepUpdate(value, "grower");
      },
    },
    irrigated: {
      get() {
        return this.submission_soil.irrigated;
      },
      set(value) {
        this.handleSubmissionDeepUpdate(value, "irrigated");
      },
    },
    customer_grower_options () {
      return this.customer_grower && this.customer_grower.models && this.customer_grower.models.map((grower) => {
        return {
          value: grower.id,
          text: grower.name
        }
      }) || []
    },
  },
  validations: {
    grower: { required },
  },
  watch: {
    selected_customer_grower_id (value) {
      if (value) {
        const customer_grower = this.customer_grower.models.find((grower) => grower.id === value)
        this.grower = customer_grower.name
        this.handleSubmissionUpdate(value, "customer_grower_id")
      } else {
        this.grower = null
        this.handleSubmissionUpdate(null, "customer_grower_id")
      }
    }
  },
  mounted () {
    this.fetchCustomerGrower()
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    handleSubmissionUpdate(value, field) {
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value,
        name: field,
      });
    },
    handleSubmissionDeepUpdate(value, field) {
      this.handleSubmissionUpdate(
        { ...this.submission_soil, [field]: value },
        "submission_soil"
      );
    },
    fetchCustomerGrower () {
      const collection = new CustomerGrowerCollection()
      const filter = collection.getFilter()

      filter.filterEquals('customer.id', this.projectFormStepOne.customer_id)

      collection.fetch().then(() => {
        this.customer_grower = collection
      })
    }
  },
};
</script>
